import { useCallback } from 'react';
import metaPixelService from '../services/metaPixelService';

/**
 * Custom hook for Meta Pixel tracking
 * Provides easy access to Meta Pixel tracking functions throughout the app
 */
export const useMetaPixel = () => {
  // Track page views
  const trackPageView = useCallback((pageName) => {
    metaPixelService.pageView(pageName);
  }, []);

  // Track custom events
  const trackEvent = useCallback((eventName, parameters = {}) => {
    metaPixelService.track(eventName, parameters);
  }, []);

  // Track conversions with value
  const trackConversion = useCallback((eventName, parameters = {}) => {
    metaPixelService.trackConversion(eventName, parameters);
  }, []);

  // Track lead generation
  const trackLead = useCallback((leadData = {}) => {
    metaPixelService.trackLead(leadData);
  }, []);

  // Track user registration
  const trackRegistration = useCallback((userData = {}) => {
    metaPixelService.trackRegistration(userData);
  }, []);

  // Track purchases/subscriptions
  const trackPurchase = useCallback((purchaseData = {}) => {
    metaPixelService.trackPurchase(purchaseData);
  }, []);

  // Track form submissions
  const trackFormSubmission = useCallback((formType, formData = {}) => {
    metaPixelService.trackFormSubmission(formType, formData);
  }, []);

  // Track website analysis requests
  const trackWebsiteAnalysis = useCallback((analysisData = {}) => {
    metaPixelService.trackWebsiteAnalysis(analysisData);
  }, []);

  // Track support ticket creation
  const trackSupportTicket = useCallback((ticketData = {}) => {
    metaPixelService.trackSupportTicket(ticketData);
  }, []);

  // Check if pixel is ready
  const isPixelReady = useCallback(() => {
    return metaPixelService.isReady();
  }, []);

  return {
    trackPageView,
    trackEvent,
    trackConversion,
    trackLead,
    trackRegistration,
    trackPurchase,
    trackFormSubmission,
    trackWebsiteAnalysis,
    trackSupportTicket,
    isPixelReady
  };
};
